
import { Component } from 'react'
import { connect } from 'react-redux'

import { PalliativePerformanceQuestionnaire } from '../../../../lib/Questionnaires'
import * as Card from '../../../shared/card'
import { CircularProgress } from '../../../shared/NarusMaterial'
import * as Actions from '../lib/new-actions'

import PalliativePerformanceForm from './form'

export const CATEGORY = 'Palliative Performance Scale'

class PalliativePerformance extends Component {
  constructor (props) {
    super(props)

    this.state = {
      open: true
    }

    this.handleOpenChange = this.handleOpenChange.bind(this)
  }

  UNSAFE_componentWillMount () {
    const { patientId, encounterId, dispatch } = this.props
    dispatch(
      Actions.getAssessment(
        patientId,
        CATEGORY,
        PalliativePerformanceQuestionnaire,
        encounterId
      )
    )
  }

  handleOpenChange (value) {
    this.setState({ open: value })
  }

  handleSubmit = data => {
    const { currentUser, patientId, encounterId, dispatch } = this.props
    dispatch(
      Actions.createAssessment(
        data,
        patientId,
        currentUser.id,
        CATEGORY,
        encounterId,
        PalliativePerformanceQuestionnaire
      )
    )
  }

  onCancel = () => {
    const { patientId, encounterId, dispatch } = this.props
    dispatch(
      Actions.getAssessment(
        patientId,
        CATEGORY,
        PalliativePerformanceQuestionnaire,
        encounterId
      )
    )
  }

  render () {
      const formData = this.props?.questionnaire?.[CATEGORY]?.formData
      const loading = this.props?.questionnaire?.[CATEGORY]?.loading

    return (
      <Card.Card expandable>
        <Card.Header >
          <h2>Palliative Performance Scale</h2>
        </Card.Header>
        <Card.ExpandableWrapper
          style={{ padding: '0 1rem 1rem' }}
        >
          {loading
            ? <CircularProgress />
            : (
              <PalliativePerformanceForm
                formKey='palliativePerformance'
                onSubmit={this.handleSubmit}
                initialValues={formData}
                cancel={this.onCancel}
              />
            )}
        </Card.ExpandableWrapper>
      </Card.Card>
    )
  }
}
const mapStateToProps = redux => ({
  questionnaire: redux.questionnaire,
  currentUser: redux.users.current_user,
  patientId: redux.globalVars.params.id,
    encounterId: redux?.encounter?.encounter?.document?.context_id
})
export default connect(mapStateToProps)(PalliativePerformance)
